import React, { ChangeEvent, useState, useEffect } from "react";
import logoImg from "../../assets/images/logo1.png";
import accountImg from "../../assets/images/account.png";
import passwordImg from "../../assets/images/password.png";
import { message } from "antd";
import useGlobalModel from "../../model/globalModel";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import { getToken, setToken, CLIENT_APP_CODE } from "../../utils/constants";
import { loginService } from "./LoginService"
import { auth } from "../../model/auth";
import { loginServiceAuth2, Auth2UserInfo, Auth2MenuDetail } from "./LoginServiceAuth2";
import { globalPrompt } from "@/components/message";
import { SmileTwoTone } from "@ant-design/icons";
interface IgetIpType {
    cid: string,
    cip: string,
    cname: string,
}
declare const window: Window & { returnCitySN?: IgetIpType };

export const Login = () => {
    const history = useHistory()
    const { user, setUser, setAuthRoleIdList, setMenuAuth,setShopAndOrg } = useGlobalModel();
    const [state, setstate] = useState({
        account: '',
        password: '',
        token: ''
    })
    const [checkPwd, setCheckPwd] = useState<boolean>(() => {
        let userAccount = window.localStorage.getItem('userAccount');
        let userPassword = window.localStorage.getItem('userPassword');
        if (userAccount || userPassword) {
            return true
        }
        return false
    });
    const [IP, setIP] = useState<string>("");

    const onAccountChange = (e: ChangeEvent<HTMLInputElement>) => {
        setstate({ ...state, account: e.target.value });
        checkPwd && window.localStorage.setItem('userAccount', e.target.value);
    }
    const onPasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
        setstate({ ...state, password: e.target.value })
        checkPwd && window.localStorage.setItem('userPassword', e.target.value);

    }
    useEffect(() => {
        let userAccount = window.localStorage.getItem('userAccount');
        let userPassword = window.localStorage.getItem('userPassword');
        if (userAccount || userPassword) {
            setstate({
                ...state,
                account: userAccount ?? "",
                password: userPassword ?? ""
            });
        }

        setIP(window.returnCitySN?.cip ?? "");  //设置ip
    }, [])
    useEffect(() => {
        user.token && history.push('/')
    }, [user.token])
    //设置用户菜单和资源列表
    let IsystemCode: any = {
        // "TEST": "vrm-sa",
        "TEST": "vrm-nga",
        // "PROD": "vrm-sa",
        "PROD": "vrm-nga"
    }
    let shopAndOrgParams: any = {
        "TEST": {
            shopId: "edfd761ff44f8304f1bc901c487e35bb",
            shopName: "尼日利亚海外门店",
            shopCode: "SHOP-M-00000061"
            // bentityCode: "Nor Motor Co.,Ltd."
            // bentityName: "沙特NOR MOTORS"
        },
        "PROD": {
            shopId: "edfd761ff44f8304f1bc901c487e35bb",
            shopName: "尼日利亚海外门店",
            shopCode: "SHOP-M-00000061"
            // bentityCode: "Nor Motor Co.,Ltd."
            // bentityName: "沙特NOR MOTORS"
        },
    }
    const beforeLogin = async (token: string) => {
        const REACT_APP_ENV = process.env.REACT_APP_ENV as string
        let systemCode = IsystemCode[REACT_APP_ENV]
        let { retData, retMsg, retCode } = await loginServiceAuth2.VerifyInfo({ sourceApp: systemCode, token });
        let { menus, resources, roles, shops, ...userInfo } = retData ?? {};
        setAuthRoleIdList(resources)

        //设置用户菜单所有权限列表,(递归查询到所有要展示得菜单地址。)
        let menuArr: string[] = [];
        function findMenuAll(array: Auth2MenuDetail[]) {
            array.forEach(item => {
                item.linkUrl && menuArr.push(item.linkUrl);
                if (item.children && item.children.length > 0)
                    findMenuAll(item.children);
            })
        }
        findMenuAll(menus?.[systemCode] ?? []);
        setMenuAuth(menuArr)

        if (retCode == "200") {
            setUser({ ...user, token, username: userInfo.userName, ...userInfo, shopCode: shopAndOrgParams[REACT_APP_ENV]["shopCode"],loginType: 'account',  })
            setShopAndOrg(shopAndOrgParams[REACT_APP_ENV])
            // loginServiceAuth2.recordAppLoginInfo(IsystemCode[REACT_APP_ENV], userInfo.userCode);
            globalPrompt("notification", {
                type: "success", title: "登录成功",
                duration: 3,
                text: <p className="bold"><span className="block"><SmileTwoTone /> {`您好!${userInfo.userName ?? ""}`}</span>欢迎使用云豪云修管理系统</p>
            });
            loginServiceAuth2.recordAppLoginInfo(CLIENT_APP_CODE, userInfo.userCode);
        }
    }
    //鉴权2.0登录
    const doLogin = async () => {
        try {
            if (!state.account) return message.warning("请输入账号");
            if (!state.password) return message.warning("请输入密码");
            let { retData, retMsg } = await loginServiceAuth2.Login({
                userCode: state.account,
                userPassword: state.password,
                token: state.token,
            }, { headers: { IP } })
            if (retData) {
                setToken(retData)
                beforeLogin(retData);
            } else {
                message.error("登录失败：" + retMsg)
            }
        } catch (error) {

        }
    }

    //记住密码
    const checkout = (e: any) => {
        let checked = e.target.checked;
        if (checked) {
            setCheckPwd(true);
            window.localStorage.setItem('userAccount', state.account);
            window.localStorage.setItem('userPassword', state.password);
        } else {
            setCheckPwd(false);
            window.localStorage.removeItem('userAccount');
            window.localStorage.removeItem('userPassword');
        }
    };
    return (

        <div className="container-login">
            <div className="login-warp">
                <div className="bg1">
                    <img src={logoImg} alt="" className="login-logo" />
                    <p>让天下商用车用户全程无忧</p>
                    <p>让我们的员工及合作伙伴都能过上好日子</p>
                </div>
                <div className="input-box">
                    <div className="input-title">
                        <span>用户登录</span>
                    </div>
                    <p className="account">
                        <span><img src={accountImg} alt="" /></span>
                        <input type="text" placeholder='请输入账号' value={state.account} onChange={onAccountChange}
                            onKeyUp={(e) => {
                                if (e.keyCode === 13) {
                                    doLogin();
                                }
                            }} />
                    </p>
                    <p className="password">
                        <span><img src={passwordImg} alt="" /></span>
                        <input type='password' placeholder='请输入密码' value={state.password} onChange={onPasswordChange}
                            onKeyUp={(e) => {
                                if (e.keyCode === 13) {
                                    doLogin();
                                }
                            }} />
                    </p>
                    <div className="login-input-three">
                        <span><input type="checkbox" defaultChecked={checkPwd} onClick={checkout} /> 记住密码</span>
                    </div>
                    <p className="login-but" onClick={doLogin}>登录</p>
                </div>
            </div>
        </div>
    )
}

export default Login;